import { createFileRoute } from '@tanstack/react-router';

import { SkillsScreen } from '@/screens/settings/SkillsScreen';

export const Route = createFileRoute('/_app/settings/skills')({
  component: SkillsScreen,
});
